'use client';

import { FeaturedContent, ProductCard } from '@chemist4u/newt-components';
import { storeName } from '@lib/config/brand';
import { composeThemeToken } from '@lib/mappers';
import { toSliderProductCard } from '@lib/util/mappers/product-slider';
import SkeletonProductSlider from '@modules/skeletons/components/skeleton-product-slider';
import * as Sentry from '@sentry/nextjs';
import { useEffect, useState } from 'react';
import { getSliderProducts } from './actions';

type SliderProducts = Awaited<ReturnType<typeof getSliderProducts>>;

export default function ProductSliderSection() {
  const [products, setProducts] = useState<SliderProducts | null>(null);

  useEffect(() => {
    let cancelled = false;

    getSliderProducts()
      .then((result) => {
        if (!cancelled) {
          setProducts(result);
        }
      })
      .catch((error) => {
        if (cancelled) {
          return;
        }
        Sentry.captureException(error, {
          extra: { context: 'ProductSliderSection:getSliderProducts' },
        });
        setProducts([]);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (products === null) {
    return <SkeletonProductSlider />;
  }

  if (products.length === 0) {
    return null;
  }

  return (
    <FeaturedContent
      layout="carousel"
      heading={{
        tag: 'h2',
        children: 'Explore Our Most Popular Treatments',
      }}
      subtext="Find the right treatment for you."
      theme={composeThemeToken(storeName, 'neutral-subtle')}
    >
      {products.map((product) => (
        <ProductCard {...toSliderProductCard(product)} key={product.id} />
      ))}
    </FeaturedContent>
  );
}
